<template>
  <div class="footer">
    <div class="container">
      <ul class="menu clearfix">
        <li>
          <h3 class="name">页面导航</h3>
          <a class="link" target="_blank" href="https://www.huishoubao.com/news/4">小宝课堂</a>
          <a class="link" target="_blank" href="https://www.huishoubao.com/news/9">回收心得</a>
          <a class="link" target="_blank" href="https://www.huishoubao.com/news/11">手机资讯</a>
          <a class="link" target="_blank" href="https://www.huishoubao.com/news/6789.html">人才招聘</a>
        </li>
        <li>
          <h3 class="name">质检说明</h3>
          <a class="link" target="_blank" href="https://www.huishoubao.com/news/8492.html">质检名词解释</a>
          <a class="link" target="_blank" href="https://www.huishoubao.com/news/8494.html">质检流程说明</a>
          <a class="link" target="_blank" href="https://www.huishoubao.com/news/8495.html">数据备份</a>
          <a class="link" target="_blank" href="https://www.huishoubao.com/news/8493.html">交易流程</a>
        </li>
        <li>
          <h3 class="name">商务合作</h3>
          <a class="link" rel="external nofollow" target="_blank" href="https://www.huishoubao.com/news/34.html">联系我们</a>
          <!-- <a class="link" target="_blank" rel="external nofollow" href="https://www.huishoubao.com/new-special-agent">合作加盟</a> -->
        </li>
        <li>
          <h3 class="name">企业服务</h3>
          <a class="link" rel="external nofollow" target="_blank" href="https://www.huishoubao.com/news/6791.html">服务条款</a>
          <a class="link" rel="external nofollow" target="_blank" href="https://www.huishoubao.com/news/8600.html?pid=1001">常见问题</a>
        </li>
        <li>
          <h3 class="name">关于我们</h3>
          <a class="link" rel="external nofollow" target="_blank" href="https://www.huishoubao.com/news/8496.html">关于回收宝</a>
          <a class="link" rel="external nofollow" target="_blank" href="https://weibo.com/huishoubao">微博</a>
          <a class="link" rel="external nofollow" target="_blank" @mouseenter="showWechat=true" @mouseout="showWechat=false">
            <span>微信</span>
            <div class="wechat" v-show="showWechat">
              <img class="wechat-img" v-lazy="'//s1.huishoubao.com/static/pc/1001/images/ewm0810.png'" style="">
            </div>
          </a>
        </li>
        <li class="contact-us">
          <div>
            <img class="name" v-lazy="'//s1.huishoubao.com/static/pc/1001/img/1_15_1.png'">
            <img class="icon-tel" v-lazy="'//s1.huishoubao.com/static/pc/1001/img/14_03_1.png'">
          </div>
        </li>
      </ul>
    </div>
    <div class="friend-links container">
      <h4>友情链接和企业批量回收（请联系：huishoubao@huishoubao.com.cn）</h4>
      <a v-for="(item, index) in friendLinkList" :href="item.flink" :key="index" v-text="item.fkeywords"></a>
    </div>
    <div class="copyright">
      <span>Copyright © 2012-2020 深圳回收宝科技有限公司 版权所有</span>
      <a class="link" rel="nofollow" href="https://beian.miit.gov.cn" target="_blank"> 粤ICP备14063444号</a>
      <a class="link" rel="nofollow" href="//www.cnzz.com/stat/website.php?web_id=1254005878" target="_blank" title="站长统计">站长统计,</a>
      <a class="link" rel="nofollow" href="javascript:void(0)" @click="showLicense">营业执照</a>
    </div>
  </div>
</template>

<script>
import { getFriendLink } from '@/apis/zx';
export default {
  data () {
    return {
      showWechat: false,
      friendLinkList: []
    };
  },
  methods: {
    showLicense (event) {
      window.open('https://s1.huishoubao.com/static/yyzz/hsb.pdf', '_blank');
    }
  },
  mounted () {
    getFriendLink().then(res => {
      this.friendLinkList = res._data;
    }).catch(error => {
      console.log('error_log', error);
    });
  }
};
</script>

<style lang="postcss" scoped>
.footer {
  margin-top: 40px;
  background-color: #3b3d40;
}

.copyright {
  font-size: 18px;
  line-height: 55px;
  color: #6d7074;
  text-align: center;
  border-top: 1px solid #666;
  a {
    color: #6d7074;
  }
}

.menu {
  li {
    float: right;
    width: 9%;
    height: 240px;
    text-align: left;
    margin-left: 7%;
  }
  .name {
    color: #fff;
    font-size: 16px;
    margin-top: 45px;
  }
  .link {
    position: relative;
    display: block;
    margin-top: 20px;
    font-size: 14px;
    color: #9fa3a8;
    cursor: pointer;
    &:hover {
      color: #3b9bff;
    }
  }
  .wechat {
    position: absolute;
    left: 61px;
    bottom: -55px;
  }
  .contact-us {
    width: 240px;
    margin-left: 0;
  }
  .icon-tel {
    margin-left: 10px;
  }
}

.friend-links {
  font-size: 14px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-top : 1px solid #666;
  h4 {
    font-size: 16px;
    line-height: 30px;
    color: #fff;
    font-weight: 400;
  }
  a {
    position: relative;
    display: inline-block;
    margin-top: 6px;
    padding: 0 8px;
    color: #666;
    line-height: 24px;
    &:hover {
      color: #3b9bff;
    }
    &::after {
      display: block;
      content: "";
      position: absolute;
      right: 2px;
      top: 6px;
      width: 1px;
      height: 12px;
      background-color: #666;
    }
    &:last-child {
      &::after {
        display: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/components/footer/footer.vue